<!--
  @Author: DKing
  @Desc: 导出文件,
  @Date: 2020-01-15
-->

<template>
  <div id="exportBtnComp">
    <span :class="className" @click="xhrExportFile">{{text}}</span>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
  import {checkNull, getLocal, checkObjectNull, isEmptyFun} from "../filters/filters";
  import { HTTP_CODE } from "../service/axios_constants";

  export default {
    name: "export-button",

    props:{
      className: {
        type: String,
        default: 'btnLargeLineColor'
      },
      exportUrl: String,    // 跳转路径
      exportParam: Object,  // 携带参数
      text: {
        type: String,
        default: '导出数据'
      },

      // 数据总条数，没有数据弹窗提示，默认不做限制
      exportTotalCount:{
        type: Number,
        default: 1
      },

      // 支持导出的最大条数，可根据不同接口调节，默认5w
      maxLength:{
        type: Number,
        // default: 50000
        default: 50000 // todo
      },

      //判断导出参数是否必传
      isMustPassParam: {
        type: Boolean,
        default: false 
      },

      // 在页面直接请求接口，不用链接的方式打开文件
      handleFun: {
        type: Function,
        default: function () { }
      }
    },

    components: {},

    computed: {},

    data() {
      return {
        exportUrlTemp: this.exportUrl,
        exportParamTemp: this.exportParam
      }
    },

    created() {

    },

    watch:{
      exportTotalCount:{
        deep: true,
        handler: function(){
        }
      }
    },

    mounted() {

    },

    methods: {
      xhrExportFile(formName) {

        if(this.isMustPassParam && !checkObjectNull(this.exportParam) || this.isMustPassParam && this.exportParam.batchIdList.length == 0){
          MessageBox('请选择需要导出的数据参数！', '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btnFullColor'
          })
          return
        }

        if(this.exportTotalCount < 1){
          MessageBox('暂无数据导出', '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btnFullColor'
          })
          return
        }

        if(this.exportTotalCount > this.maxLength){
          MessageBox(`最多支持导出${this.maxLength}条数据`, '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btnFullColor'
          })
          return
        }

        // 在页面直接请求接口，不用链接的方式打开文件
        if (!isEmptyFun(this.handleFun)) {
          let param = { ...this.exportParam }
          this.handleFun(param).then((res) => {
            if (res.statusCode === HTTP_CODE.suc) {
              MessageBox('数据导出中,请在导出记录中查看进度并下载', '提示', {
                confirmButtonText: '确定',
                confirmButtonClass: 'btnFullColor'
              })
            }
          });
          return;
        }

        // 是否含有url
        if (checkNull(this.exportUrl)) {
          return
        }

        // 是否含有参数
        let keyStr = '?';
        if(!checkNull(this.exportParam)){
          // keyStr = '?';
          for(let item in this.exportParam){
            keyStr = keyStr + item + "=" + this.exportParam[item] + '&'
          }
        } 

        window.open(this.exportUrl + keyStr + 'token=' + getLocal('Authorization'));

        //报名详情页面需要操作父组件
        this.$emit("closeDialog", false)
      }
    }

  }
</script>
<style lang="scss" scoped>
  @import "./../styles/variable";
  #exportBtnComp{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/export-button.vue